import EventEmitter from "eventemitter3";

import type { IModalContent } from ".";

type EventTypes = {
  openModal: (content: IModalContent) => void;
  closeModal: (callback?: () => void) => void;
};

class ModalEmitter extends EventEmitter<EventTypes> {
  emitOpenModal(content: IModalContent) {
    this.emit("openModal", content);
  }

  emitCloseModal(callback?: () => void) {
    this.emit("closeModal", callback);
  }
}

const modalEmitter = new ModalEmitter();
export default modalEmitter;
